import clsx from 'clsx';
import { ReactNode } from 'react';
import SliderSection from 'react-slick';

interface SliderInterface {
  otherClasses?: string;
  children: ReactNode;
  customClass?: string;
  customSettings: any;
  refs?: any;
}

export default function Slider({
  otherClasses,
  children,
  customSettings,
  customClass,
  refs,
}: SliderInterface) {
  const sliderClasses = clsx(otherClasses);

  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...customSettings,
  };
  return (
    <div className={sliderClasses} data-testid="slider">
      <SliderSection {...settings} className={customClass} ref={refs}>
        {children}
      </SliderSection>
    </div>
  );
}
